<template>
  <div id="app">

    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>

    <!-- navbar -->
    <div v-if="user" id="nav">
      <b-navbar spaced class="contentView">
        <template slot="brand">
          <b-navbar-item tag="router-link" :to="{ path: '/patients' }">
            <img src="@/assets/logo.png">
          </b-navbar-item>
        </template>
        <template slot="start">
          <b-navbar-item to="/patients" tag="router-link">
            Patients
          </b-navbar-item>
          <b-navbar-item to="/templates" tag="router-link">
            Templates
          </b-navbar-item>
        </template>
        <template slot="end" tag="div">
          <b-button class="is-info" @click="logout()" px="0" rounded outlined>
            <strong>Logout</strong>
          </b-button>
          <!-- <b-navbar-item v-if="user.role==='OWNER'" to="/account" tag="router-link"> -->
            <b-button v-if="user.role==='OWNER'" to="/account" tag="router-link" class="is-info ml-1" rounded>
              <b-icon icon="account" type="is-white" />
            </b-button>
          <!-- </b-navbar-item> -->
        </template>
      </b-navbar>
    </div>

    <!-- check for payment -->
    <div v-if="ready && !stripe_isLoading">
      <b-modal
        v-model="showStripePopup"
        :destroy-on-hide="true"
        has-modal-card
        trap-focus
        aria-role="dialog"
        aria-label="You do not have an active subscription"
        aria-modal>
        <template> <!-- #default="props" -->
          <div class="modal-card has-text-left" style="width: 40rem">
            <header class="modal-card-head is-flex is-justify-content-space-between is-align-items-center">
              <p class="modal-card-title title is-4 mb-0">
                Your Practice is Inactive
              </p>
              <b-button class="is-info" @click="logout()" rounded outlined>
                <strong>Logout</strong>
              </b-button>
            </header>
            <section class="modal-card-body">
              <div v-if="user && user.role !== 'OWNER'">
                <p class="is-size-5">Contact your practice director and ask to check their payment or trial status.</p>
              </div>
              <div v-else>
                <stripe />
              </div>
            </section>
            <footer class="modal-card-foot">
            </footer>
          </div>
        </template>
      </b-modal>
    </div>

    <!-- TODO: move v-if="ready" here so that no components have to wait for ready -->
    <router-view class="routerView" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import stripe from '@/components/owner/stripeComponents';

export default {
  name: 'app',
  components: {
    stripe,
  },
  computed: {
    showStripePopup: {
      get() {
        if (!this.subscription) return true
        else return false
      },
      set() { // has to be blank since v-model="show StripPopup" doesn't only get, also can set
        return
      }
    },
    isLoading() { // if the page is loading, or if the user is persisted and practice has not yet resolved
      return this.auth_isLoading || this.main_isLoading || (this.user && !this.ready)
    },
    ...mapState({
      auth_isLoading: state => state.auth.isLoading,
      user: state => state.auth.user,
      practice: state => state.auth.practice,
      main_isLoading: state => state.isLoading,
      ready: state => state.auth.isReady, // wait for practice and user are loaded
      stripe_isLoading: state => state.stripe.isLoadingSmall,
    }),
    ...mapGetters({
      subscription: "stripe/getSubscription"
    })
  },
  methods: {
    ...mapActions({
      logout: "auth/logout",
    })
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh!important;
  background-color: #e4e7eb;
}
body {
  background-color: #e4e7eb!important;
}

.routerView {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contentView {
  width: clamp(300px, 85vw, 1080px);
}

.isinfoCss {
  background-color: #18A0FB;
}


#nav {
  display: flex;
  justify-content: center;
  background-color: white;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #18A0FB;
    }
  }
}
</style>
